import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <path
      d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm0 4.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm2.5 14h-4v-2h1v-4h-1v-2h3v6h1v2z"
      fill={ fill }
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
